import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllSchools as apiDeleteAllSchools } from "../../api/apiSchools";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllSchools() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAllSchools, isPending: isDelete, data: results, error } = useMutation({
        mutationFn: (req) => apiDeleteAllSchools(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["schools"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAllSchools, isDelete, error, results };
}
